<template>
   <div>
      <!-- Categories List -->
      <div v-if="!showDetails" class="custom-container-1440 container-res">
         <i class="fc-icon-chat-cat"></i>
         <div class="container">
            <div class="boxes-list">
               <div
                  v-for="(box, index) in boxes"
                  :key="index"
                  class="box"
                  :class="{ selected: selectedIndex === index }"
                  @click="selectBox(index)"
               >
                  <div :class="['icon', box.icon]"></div>
                  <p class="text">{{ box.text }}</p>
               </div>
            </div>
         </div>
      </div>

      <!-- Details Box -->
      <div v-if="showDetails" class="custom-container-1440 container-res">
         <div class="container">
            <div class="details-box">
               <div class="container-ques">
                  <i class="circle-shape font-icon-brought-center fc-icon-chat-que"></i>
                  <div class="question-box question response-message">
                     <pre class="question_pre">{{ selectedBox.detailsHeading }}</pre>
                     <button class="close-btn" @click="closeDetails">✕</button>
                  </div>
               </div>
               <div class="container-res">
                  <i class="circle-shape font-icon-brought-center fc-icon-chat"></i>
                  <div class="response-box">
                     {{ selectedBox.detailsText }}
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'Boxes',
   data() {
      return {
         selectedIndex: null, // To track which box is selected
         showDetails: false, // To toggle visibility of the details box
         boxes: [
            {
               icon: 'fa-question-circle',
               text: 'Question About Documentation',
               detailsHeading: 'Question About Documentation',
               detailsText: 'What types of charts are available in FusionCharts?',
            },
            {
               icon: 'fa-chart-line',
               text: 'Create a Chart',
               detailsHeading: 'Create a Chart',
               detailsText: 'I want to create a chart.',
            },
            {
               icon: 'fa-cogs-chatai',
               text: 'Customize Your Chart',
               detailsHeading: 'Customization Details',
               detailsText: 'Help me customize my chart.',
            },
            {
               icon: 'fa-bug-chatai',
               text: 'Troubleshooting Code',
               detailsHeading: 'Troubleshooting Details',
               detailsText: 'I want to fix a bug in my code.',
            },
         ],
      };
   },
   computed: {
      selectedBox() {
         return this.selectedIndex !== null
            ? this.boxes[this.selectedIndex]
            : { detailsHeading: '', detailsText: '' };
      },
   },
   methods: {
      selectBox(index) {
         this.selectedIndex = index; // Update selected index
         // this.showDetails = true; // Show details box
         this.$emit('user-question', this.boxes[index].detailsText);
         // this.$emit('update-data', this.boxes[index].detailsText);
      },
      closeDetails() {
         this.showDetails = false; // Hide details box
         this.selectedIndex = null; // Reset selected index
         this.$emit('update-data', '');
      },
   },
};
</script>

<style scoped>
.container {
   display: flex;
   flex-direction: column; /* Stack boxes and details box vertically */
   gap: 10px; /* Space between boxes and details box */
   padding: 10px; /* Padding around the container */
   margin: 0 auto; /* Center the container horizontally */
   box-sizing: border-box; /* Ensure padding is included in the container's width */
}

.boxes-list {
   display: flex;
   flex-wrap: wrap; /* Allow boxes to wrap to the next line if necessary */
   gap: 10px; /* Space between boxes */
}

.box {
   display: flex;
   align-items: center; /* Align items vertically in the center */
   border: 1px solid #ccc; /* Border style */
   border-radius: 8px; /* Rounded corners */
   text-align: left; /* Align text to the left */
   padding: 10px; /* Add padding inside the box */
   min-width: 200px; /* Minimum width of the box */
   flex: 1 1 200px; /* Allow boxes to grow and shrink with a base width of 200px */
   box-sizing: border-box; /* Include padding and border in the box's total width */
   cursor: pointer; /* Change cursor to pointer on hover */
   box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05); /* Add box shadow */
}

.box:hover {
   transform: translateY(-4px); /* Slight lift effect on hover */
   transition: all 0.2s ease;
}

.icon {
   width: 20px; /* Set icon size */
   height: 20px; /* Set icon size */
   background-size: contain; /* Ensure background image fits within the container */
   background-repeat: no-repeat; /* Prevent background image from repeating */
   margin-right: 10px; /* Space between icon and text */
}

.fa-question-circle {
   background-image: url('/public/images/chat-feedback/fa-question-circle.svg');
}

.fa-chart-line {
   background-image: url('/public/images/chat-feedback/fa-chart-line.svg');
}

.fa-cogs-chatai {
   background-image: url('/public/images/chat-feedback/fa-cogs-chatai.svg');
}

.fa-bug-chatai {
   background-image: url('/public/images/chat-feedback/fa-bug-chatai.svg');
}

.text {
   font-size: 14px; /* Font size for text */
   margin: 0; /* Remove margin from text */
}

.container-ques {
   display: flex;
   align-items: center; /* Center align items vertically */
   justify-content: space-between; /* Space out items within the container */
}

.question-box {
   display: flex;
   align-items: center; /* Center align items vertically */
   flex: 1; /* Allow question-box to grow */
   margin-right: 10px; /* Space between question-box and close button */
}

.close-btn {
   background: none; /* Remove default button background */
   border: none; /* Remove default button border */
   font-size: 20px; /* Font size for close button */
   color: #007bff; /* Color for close button */
   cursor: pointer; /* Pointer cursor on hover */
}

.container-res {
   display: flex;
   align-items: center; /* Center align items vertically */
}

.font-icon-brought-center {
   color: white; /* Color for the icon */
   font-size: 24px; /* Size of the icon */
}

.question_pre {
   background: none;
   margin-bottom: 0px;
   padding: 0px;
   font-size: 1.6rem;
   font-weight: normal;
   color: inherit;
   font-family: inherit;
   width: 100%;
}

.fc-icon-chat-cat {
   height: 24px;
   width: 24px;
   display: inline-block;
   background-repeat: no-repeat;
   margin-right: 10px;
}
</style>
